import axios from '../axios'

/* 
 * 上传
 */

/**
 * 单张图片上传
 * @param {*} service   服务模块 例：admin
 * @param {*} data    请求参数
 * @returns 
 */
 export const uploadImg = (service, data) => {
    return axios({
        url: '/' + service + '/api/common/uploadImg',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/upload.js